module.exports = __webpack_public_path__ + "img/industrial_design.40e5af9d.jpg";